import { CoverExtra, DeliveredDutyPaidExtra, SignatureExtra } from '../../components/ExtrasHelper';
import { SmartSendProvider } from '~/lib/consts/providers';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { SumNumber } from './ArrayHelper';
import { IsSmartSend } from './SmartSendSummaryGenerator';
import { IossNumber } from '../consts/ItemMetaConstants';

export function ItemExtrasAutoApplier(item: SmartSendItemApiModel) {
  // Add Proof of delivery for EVRI where the item value is £50 or more.
  if (SettingsCache.profile.startsWith('EVRI.SME')) {
    const val = 50;
    if (
      IsSmartSend(item) &&
      item.MarketplaceStatus === 'Sold' &&
      item.Status === 'Active' &&
      (item.Value >= val || SumNumber(item.MarketplaceOrderLines.map((m) => m.Value)) >= val) &&
      item.Extras.some((x) => x.Id == CoverExtra) &&
      !item.Extras.some((x) => x.Id == SignatureExtra)
    ) {
      item.Extras.push({ Id: SignatureExtra, Name: 'Signature', Provider: SmartSendProvider });
    }
  }

  // Auto Add Delivered Duty Paid for ASENDIA profiles where DDU is unavailable and the user cannot use IOSS
  if (
    SettingsCache.profile.startsWith('ASENDIA') ||
    SettingsCache.settings.Features.includes('AutoAddDdpWhenDduUnavailable')
  ) {
    if (
      IsSmartSend(item) &&
      !item.Extras.some((x) => x.Id === DeliveredDutyPaidExtra) &&
      (item.State?.validation?.QuoteState?.Quote?.Service?.Tags?.includes('dduUnavailable') ||
        item.State?.validation?.QuoteState?.Quote?.Tags?.includes('dduUnavailable')) &&
      !item.State.validation.QuoteState.ItemValidation?.some((x) => x.name === IossNumber) &&
      item.State.validation.QuoteState.Quote.Options?.some(
        (o) =>
          o.AvailableExtras.some((e) => e.Id === DeliveredDutyPaidExtra) ||
          o.Extras.some((e) => e.Id === DeliveredDutyPaidExtra)
      )
    ) {
      item.Extras.push({ Id: DeliveredDutyPaidExtra, Name: 'Delivered Duty Paid', Provider: SmartSendProvider });
    }
  }

  return item;
}
